const Cookies = require('components/frontend/js-cookie.js');

module.exports = function () {

    const COOKIE_NOTICE = document.getElementById('mtt-cookie-notice');
    const COOKIE_BUTTON = COOKIE_NOTICE.querySelector('.button');
    const COOKIE_CLOSE = COOKIE_NOTICE.querySelector('.mtt-cookie-notice__close');
    const DEFAULT_CLASSES = COOKIE_NOTICE.className;
    const MOBILE_BREAKPOINT = 600;
    
    function hideCookieNotice() {
        Cookies.set('hide_cookie_popup_notice', 1);
    
        COOKIE_NOTICE.className = DEFAULT_CLASSES;
    }
    
    function showCookieNotice() {
        if(Cookies.get('hide_cookie_popup_notice') === undefined) {
            COOKIE_NOTICE.className = DEFAULT_CLASSES + ' show';
        }
    }
    
    COOKIE_BUTTON.addEventListener('click', hideCookieNotice);
    COOKIE_CLOSE.addEventListener('click', hideCookieNotice);
    
    if (window.innerWidth > MOBILE_BREAKPOINT) {
        showCookieNotice();
    }

}




// WEBPACK FOOTER //
// ./resources/js/components/frontend/cookie-notice.js